import { LoadableRoute } from 'routes/utils/loadable';

export const ConfirmEmailContainer = LoadableRoute({
  loader: () => import(/* webpackChunkName: "ConfirmEmail" */ './ConfirmEmail'),
});
